import { useComplianceStore } from '../store/complianceStore';
import type { ComplianceStore } from '../store/complianceStore.types';

/**
 * Policy types that can be checked for feedback enablement.
 */
export type FeedbackPolicyType = 'UserFeedbackFormEnabled' | 'SurveyFeedbackFormEnabled';

/**
 * Hook to check if a specific feedback policy is enabled.
 *
 * Feedback is considered enabled if:
 * - The policy is explicitly set to `true`, OR
 * - The policy is not configured (`null`) - defaults to enabled
 *
 * Feedback is only disabled when:
 * - Policies haven't loaded yet (returns `false` to match legacy behavior), OR
 * - The policy is explicitly set to `false`
 *
 * @param policy - The policy to check ('UserFeedbackFormEnabled' or 'SurveyFeedbackFormEnabled')
 * @returns `true` if feedback is enabled, `false` otherwise
 */
export const useIsFeedbackEnabled = (policy: FeedbackPolicyType): boolean => {
  const policies = useComplianceStore((state: ComplianceStore) => state.policies);

  if (!policies) {
    return false;
  }

  return policies[policy] === true || policies[policy] == null;
};
